import React, { useContext, useState } from 'react';
import '../App.css';
import './tool.css';
import CSS from 'csstype';
import { useAppSelector } from '../app/hooks';

// types

// icons
import spinnerDark from '../icons/spinner-dark.64.gif';
import spinnerLight from '../icons/spinner-light.64.gif';

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export default function PleaseWait(props: {
  text: string;
  visible: boolean;
  small?: boolean;
}) {
  //
  //	--------------------------------------------------------------------------
  //
  //	C O N T E X T   V A R I A B L E S   A N D   F U N C T I O N S
  //
  //	--------------------------------------------------------------------------

  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  // global state variables.
  const sG_DarkMode: boolean = useAppSelector((state) => state.global.darkMode);

  //	------------------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	------------------------------------------------------------

  return (
    <div
      className="text-colour"
      style={
        props.visible === true
          ? {
              display: 'flex',
              flexDirection: 'row',
              width: 'auto',
              alignItems: 'center',
              height: props.small === true ? '25px' : '40px',
            }
          : {
              display: 'none',
            }
      }
    >
      <img
        src={sG_DarkMode === true ? spinnerDark : spinnerLight}
        role="presentation"
        alt=""
        width={props.small === true ? '25px' : '40px'}
        height={props.small === true ? '25px' : '40px'}
      />
      <div style={{ flex: '0 0 5px' }} />
      {props.text}
    </div>
  );
  //
} // ToolButton
